/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import {
  init as sentryInit,
  browserTracingIntegration,
  replayIntegration,
  browserProfilingIntegration,
  thirdPartyErrorFilterIntegration
} from '@sentry/react-router'
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { version } from '../package.json'

sentryInit({
  dsn: 'https://de9815b17820337c543cebb016a06358@o4507684335845376.ingest.de.sentry.io/4508048362045520',
  environment: process.env.NODE_ENV,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react-router/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  release: `main-template@${version}`,
  ignoreErrors: [/fbq.*/, /ttq.*/, /gtag.*/],

  beforeSend(event) {
    if (event.request?.url) {
      const url = new URL(event.request.url)
      if (
        url.protocol === 'chrome-extension:' ||
        url.protocol === 'moz-extension'
      ) {
        return null
      }
    }
    return event
  },
  integrations: [
    browserTracingIntegration(),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    }),
    browserProfilingIntegration(),
    thirdPartyErrorFilterIntegration({
      filterKeys: ['main-7A4A262E-695F-4DA9-A0AE-B01E63FDACB8'],
      behaviour: 'drop-error-if-contains-third-party-frames'
    })
  ],

  tracesSampleRate: process.env.NODE_ENV !== 'development' ? 0.1 : 0.2,
  // Set `tracePropagationTargets` to declare which URL(s) should have trace propagation enabled
  // tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  )
})
